import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['%'] as const;

const validator = AbstractMeasurement.minMax.extend({
    unit: z.enum(units).default('%'),
});

export const Humidity = {
    validator,
    units,
};
